import { checkMobile } from 'services/lambda/check-mobile';
import env from '@beam-australia/react-env';

const web = env('SOURCE_WEB');
const mobile = env('SOURCE_MOBILE');

export const getSource = (userAgent: string) =>
    checkMobile(userAgent, mobile, web);
